import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'
import classNames from 'classnames'

import { LINK_ID_REG } from '@aytm/app/stats/page/question-views/components/lib/constants'
import { customAnswersTitle, formatAmounts } from '@aytm/app/stats/lib/util/helpers'
import { isFeatureDisabled, openCommentsPanel, scrollToQuestionOriginal } from '@aytm/app/stats/lib/stat-page'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/question-views/components/reference-link/styles/ReferenceLink.module.scss'

const ReferenceLink = ({ id, link, answer, isReportXpert }) => {
  const hasComments = typeof answer?.comments !== 'undefined' && 0 < Number(answer.comments)

  const formatted = hasComments ? formatAmounts(answer, 'comments') : ''

  const handleClick = event => {
    event.preventDefault()

    const m = link.match(LINK_ID_REG)

    scrollToQuestionOriginal((m[1] + m[2]).toLowerCase(), m[3])
  }

  // Opens the comments panel on the referenced question — mirrors the heatmap block's
  // comments handler. No query segment: this surface points at a whole question, with no
  // batch or cluster to narrow it down.
  const handleCommentsClick = event => {
    event.preventDefault()

    if (isFeatureDisabled('comments_page')) return

    const m = link.match(LINK_ID_REG)
    // The panel is scoped by a question id, and both of these already are one -- the link's own, or
    // this block's with any batch or variant suffix dropped. Converting to a position and back only
    // to arrive at the id we started from is a round trip with nowhere to go.
    const path = !id || isReportXpert ? (m[1] + m[2]).toLowerCase() : id.split('-')[0].split('_')[0].toLowerCase()

    openCommentsPanel({ event, path, isReportXpert })
  }

  return (
    <div className={style.wrapper}>
      <span className={style.link} {...pressable(handleClick)}>
        Explore further in {link.toUpperCase()}
      </span>
      {hasComments ? (
        <span
          className={classNames(style.comments, 'p-right')}
          title={customAnswersTitle(answer.comments, formatted)}
          {...pressable(handleCommentsClick)}
        >
          {formatted}
          <i className="icon-aytmfd-comments-v2" />
        </span>
      ) : null}
    </div>
  )
}

ReferenceLink.propTypes = {
  id: PropTypes.string,
  link: PropTypes.string,
  answer: answerPropType,
  isReportXpert: PropTypes.bool
}

export default ReferenceLink
